// @flow
import { Record, Map } from "immutable"
import { isNil, pick } from "ramda"

import { PLACE_TYPES } from "common/consts/place"
import { placeToLocationTypes } from "../services/locations/placeLocationMapper"

export type City = { id: string, name: string }

export type LocationNearby = {|
  id: string,
  duration: Number,
  distance: Number,
|}

const PlaceRecord = Record({
  id: null,
  value: "", // whole name with brackets
  slug: "", // url slug
  lat: null,
  lng: null,
  type: null, // type in integer
  flagParentId: null,
  parentIds: [],
  population: null, // not used
  country: null, // deprecated! it is somewhere used as object, don't use it like that, in future it could be used for country string
  rank: 0,
  numberOfAirports: 0,
  city: null,
  code: "",
  name: "",
  countryName: "", // TODO: merge this with country prop to an object (needs bigger refactor)
  continent: null,
  locationsNearby: null,
  tags: null,
  neighbours: null,
})

class Place extends PlaceRecord {
  id: string

  value: string

  slug: string

  lat: ?number

  lng: ?number

  type: number

  flagParentId: ?string

  parentIds: Array<string>

  population: number

  rank: number

  city: ?City

  code: string

  name: ?string

  numberOfAirports: number

  countryName: ?string

  continent: ?string

  locationsNearby: ?Array<LocationNearby>

  tags: ?Array<{ tag: string }>

  neighbours: ?Array<string>

  getId(): string {
    return this.get("id")
  }

  getType(): string {
    return placeToLocationTypes[this.get("type")] || "unknown"
  }

  getCityId(): string {
    switch (this.get("type")) {
      case PLACE_TYPES.AIRPORT:
      case PLACE_TYPES.TRAIN_STATION:
      case PLACE_TYPES.BUS_STATION:
        return this.get("city").id
      default:
        return this.get("id")
    }
  }

  checkLatLng(): boolean {
    return (
      !isNil(this.get("lat")) &&
      !isNil(this.get("lng")) &&
      !(this.get("lat") === 0 && this.get("lng") === 0)
    )
  }

  isIncludedIn(where: Array<?string>): boolean {
    return where.includes(this.id)
  }

  isIncludedDeepIn(where: Array<?string>): boolean {
    return this.parentIds.some(id => where.includes(id))
  }

  getGeo() {
    return !isNil(this.lat) && !isNil(this.lng) && pick(["lat", "lng"], this)
  }

  /* currently unused
  getFlagSuffix(): string {
    switch (this.get("type")) {
      case PLACE_TYPES.VIRTUAL:
      case PLACE_TYPES.COUNTRY: {
        // suburbs are 'countries' and they can have parents
        const id = this.flagParentId || this.id
        return id === "ZZ" ? "anywhere" : id.toLowerCase()
      }
      case PLACE_TYPES.AUTONOMOUS_TERRITORY: {
        // autonomous territories are shown with their own flags
        return this.id.toLowerCase()
      }
      case PLACE_TYPES.CITY: {
        const flagParentId = this.get("flagParentId")
        return flagParentId
          ? flagParentId.toLowerCase()
          : this.get("id")
              .slice(-2)
              .toLowerCase()
      }
      case PLACE_TYPES.TRAIN_STATION:
      case PLACE_TYPES.AIRPORT:
      case PLACE_TYPES.BUS_STATION: {
        const flagParentId = this.get("flagParentId").toLowerCase()
        return flagParentId.substr(flagParentId.lastIndexOf("_") + 1, 2)
      }
      default:
        return ""
    }
  }

  isVirtual(): boolean {
    return this.type === PLACE_TYPES.VIRTUAL
  }
  */

  // eslint-disable-next-line flowtype/no-weak-types
  static fromPlainJS(plain: ?any = {}): Place {
    return new Place(plain)
  }
}

export const PlacesStateRecord = Record({
  places: Map({}),
  loading: true,
  error: false,
})

export default Place
